import { AbstractParser } from "../../parser";
import { Injectable } from "@angular/core";
import { ImportClusterResult } from "src/app/ui/models/domains/pbm/clusters/import-cluster-result";
import { parseImportClustersResults } from "./cluster-functions";
import { ExportOrderKey } from "src/app/ui/models/domains/pbm/exports/export-order-key";

@Injectable()
export class ImportFileClusterParser extends AbstractParser<ImportClusterResult> {
  parse(payload: any): ImportClusterResult {
    const importClusterResult = new ImportClusterResult();
    importClusterResult.setMessageResult(payload.Message);

    const exportKey = new ExportOrderKey(payload.ExportKey);
    importClusterResult.setExportKey(exportKey);

    importClusterResult.setAdicionados(payload.Adicionados);
    importClusterResult.setRemovidos(payload.Removidos);

    return importClusterResult;
  }
}
